import {Button, Stack, styled, Tooltip, tooltipClasses, TooltipProps, Typography} from "@mui/material";

export const PixelStatusTooltip = styled(({className, children, ...props}: TooltipProps) => (
    <Tooltip {...props} classes={{popper: className}} children={children}/>
))(() => ({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: "#FFFFFF",
        maxWidth: 270,
        minWidth: 127.5,
        width: "fit-content",
        borderRadius: "0.9rem",
        padding: "3rem",
        boxShadow: '4px -5px 19px 0 rgba(0, 0, 0, 0.09)',
        marginBottom: '0.2rem !important'
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "#FFFFFF",
        width: 0,
        height: 0,
        borderLeft: '1rem solid transparent',
        borderRight: '1rem solid transparent',
        borderTop: '1.5rem solid #FFFFFF',
        marginBottom: '-1rem !important'
    }
}))

PixelStatusTooltip.defaultProps = {
    arrow: true,
    placement: 'top',
    leaveTouchDelay: 5000
}

export const PixelStatusTooltipContainer = styled(Stack)`
  align-items: center;
  & svg {
    width: 2.4rem;
    height: 2.4rem;
    margin-bottom: 1rem;
  }
`

export const PixelStatusTooltipText = styled(Typography)(({theme}) => ({
    color: theme.palette.text.medium,
    marginBottom: '0.5rem'
}))

PixelStatusTooltipText.defaultProps = {
    variant: 'h3'
}

export const PixelStatusTooltipButton = styled(Button)(({theme}) => ({
    textDecoration: 'underline',
    textTransform: 'uppercase',
    fontSize: '1rem',
    fontWeight: 500,
    color: theme.palette.text.medium,
    padding: 0,

    '&:hover': {
        textDecoration: 'underline',
        background: 'none'
    }
}))


PixelStatusTooltipButton.defaultProps = {
    variant: 'text'
}
